module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"videoProcessingFailed":"The interview is still not opened. You can ask sender to open it."}}')
  delete Component.options._Ctor
}
